module.exports = __webpack_public_path__ + "img/rpjh-zczz-t.1b9dfeb3.png";